import {Typography} from "@mui/material"
import Grid from "@mui/material/Grid"
import {useLocation} from "react-router-dom"

import {StripeDebitCardWithCPAForm} from "@indebted/stripe"
import {Page} from "@indebted/components/Page"
import {DiscountMessage} from "@indebted/components/DiscountMessage"

function DebitCardWithCPAForm({
	i18n,
	discountMessage,
	termsOfDiscountOffer,
	locale,
	onSubmitCPA,
	publishableKey,
	requiresPostcode = false,
	acceptedCardsList,
	morePaymentMethodsAvailable,
	walletPayMethods,
	providerData,
	paymentPlanID,
	requestESIGNConsent,
	esignConsent,
}) {
	const location = useLocation()

	return (
		<Page padded>
			<Grid container direction="column" alignItems="stretch" spacing={5} padding={0}>
				<Grid>
					<DiscountMessage discountMessage={discountMessage} />
				</Grid>
				<Grid>
					<Typography variant="h6">{i18n.Header}</Typography>
				</Grid>
				<Grid>
					<Typography>{i18n.Title}</Typography>
				</Grid>

				<Grid>
					<StripeDebitCardWithCPAForm
						i18n={i18n}
						termsOfDiscountOffer={termsOfDiscountOffer}
						locale={locale}
						onSubmitCPA={onSubmitCPA}
						publishableKey={publishableKey}
						hidePostalCode={!requiresPostcode}
						acceptedCardsList={acceptedCardsList}
						morePaymentMethodsAvailable={morePaymentMethodsAvailable}
						walletPayMethods={walletPayMethods}
						paymentMethodSelectionLink={`PaymentMethodSelection${location.search}`}
						providerData={providerData}
						paymentPlanID={paymentPlanID}
						requestESIGNConsent={requestESIGNConsent}
						esignConsent={esignConsent}
					/>
				</Grid>
			</Grid>
		</Page>
	)
}

export {DebitCardWithCPAForm}
